import { render, staticRenderFns } from "./CreateMailAttachment.vue?vue&type=template&id=29a69d4e&scoped=true"
import script from "./CreateMailAttachment.vue?vue&type=script&lang=js"
export * from "./CreateMailAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a69d4e",
  null
  
)

export default component.exports